// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"27bb866f","452":"f64401c6","787":"d821f116","952":"91d1f7ee"}[chunkId] + ".chunk.js";
};